import * as React from 'react';
import {FC, useEffect, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {LogIntergrationViewState} from './LogIntergrationViewState';
import {IntegrationInstructions} from '../../components/IntegrationInstructions';
import {useParams} from 'react-router-dom';
import {redirectTo} from '../../routing/browserHistory';

export const LogIntegrationView: FC = observer(() => {
    const {logId} = useParams();

    const [state] = useState(() => new LogIntergrationViewState());

    useEffect(() => {
        if (!logId) {
            redirectTo('/');
        } else {
            state.load(logId);
        }
    }, [logId]);

    return <div>
        {state.item &&
            <IntegrationInstructions
                logType={state.item.logType}
                title={state.item.name}
                logId={state.item.logId}/>}
    </div>;
});
